const theme = {
  primary: '#613dc1',
  secondary: '#38E54D',
  gray: '#F0F8EA',
  background: '#F3EFF5',
};

export default theme;
